module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-for-use.1717e53b.jpg";